import React from 'react';
import { Accordion } from './partials/Accordion';
import { useAccordion } from './useAccordion';
import { AccordionToggleButton } from './partials/AccordionToggleButton';
import { AccordionTitle } from './partials/AccordionTitle';
import { AccordionIcon } from './partials/AccordionIcon';
import { AccordionElement } from './partials/AccordionElement';
import { ID } from '../../../types/api/ID';
import { AccordionHeader } from './partials/AccordionHeader';
import { AccordionPanel } from './partials/AccordionPanel';
import { AccordionHeading } from './partials/AccordionHeading';

export interface AccordionItem extends ID {
  category: string;
  disabled?: boolean;
}

export interface DefaultAccordionProps<TItem extends AccordionItem> {
  initialActiveElementId?: string | null;
  headlineHierarchy?: number;
  data: TItem[];
  children: (item: TItem) => React.ReactNode;
}

export function DefaultAccordion<T extends AccordionItem>(props: DefaultAccordionProps<T>) {
  const { getAccordionProps, items } = useAccordion(props.data, {
    initialActiveElementId: props.initialActiveElementId,
  });
  const { children, headlineHierarchy } = props;

  return (
    <Accordion {...getAccordionProps()}>
      {items.map(item => (
        <AccordionElement {...item.getElementProps()} key={`AccordionElement-${item.id}`}>
          <AccordionHeader>
            <AccordionHeading hierarchy={headlineHierarchy}>
              <AccordionToggleButton {...item.getToggleButtonProps()} disabled={!!item.disabled}>
                <AccordionTitle category={item.category} />
                <AccordionIcon />
              </AccordionToggleButton>
            </AccordionHeading>
          </AccordionHeader>
          <AccordionPanel {...item.getPanelProps()}>{children(item)}</AccordionPanel>
        </AccordionElement>
      ))}
    </Accordion>
  );
}
